import * as Zod from 'zod';

import { translate } from 'utils/i18n';
import {
    IBasicOfferEventListItemForCertificateFragment,
    ISkillInputOptionFragment,
} from 'graphql/types';
import { TCertificateOption } from 'certificate/types';
import { ESkillCertificateOfferEventDialogMode } from 'skill/types';

export function getSkillCertificateOfferEventDialogValidator(
    mode: ESkillCertificateOfferEventDialogMode,
    requireSkill = true
) {
    const baseShape = {
        // When the certificate is locked to a single one
        // there is no skill to pick, so it is not required to submit.
        skill: requireSkill
            ? Zod.custom<ISkillInputOptionFragment | null>((val) => !!val, {
                  message: translate('validate.required'),
              })
            : Zod.custom<ISkillInputOptionFragment | null>().nullable(),
        certificate: Zod.custom<TCertificateOption | null>((val) => !!val, {
            message: translate('validate.required'),
        }),
    };

    if (mode === ESkillCertificateOfferEventDialogMode.Notify) {
        return Zod.object({
            ...baseShape,
            offerEvent:
                Zod.custom<IBasicOfferEventListItemForCertificateFragment | null>().nullable(),
            message: Zod.string().trim().min(1, translate('validate.required')),
        });
    }

    return Zod.object({
        ...baseShape,
        offerEvent:
            Zod.custom<IBasicOfferEventListItemForCertificateFragment | null>(
                (val) => !!val,
                {
                    message: translate('validate.required'),
                }
            ),
        message: Zod.string(),
    });
}
